const styledComponents = require('styled-components');
const styled = styledComponents.default || styledComponents;
const { css, keyframes } = styledComponents;
const { normaliseColor, getRGBOpacity } = require('../../utils/colors');

// Basic tertiary-like style
const basicStyle = (props) => {
  const theme = props.theme || {};
  const buttonTheme = theme.button || {};
  return css`
    background: transparent;
    font-size: ${buttonTheme.fontSize};
    border-radius: ${buttonTheme.border && buttonTheme.border.radius};
    color: ${props.textColor || normaliseColor(buttonTheme.textColor, theme)};
    font-family: ${buttonTheme.fontFamily || theme.defaultFontFamily};
    height: 100%;
    width: ${props.width};
    min-width: ${buttonTheme.minWidth};

    padding: ${buttonTheme.padding};
    ${props.margin && `margin: ${props.margin}`}
    ${props.disabled && 'opacity: 0.3;'}
  `;
};

const primaryStyle = (props) => css`
  background: ${props.color ||
  normaliseColor(props.theme && props.theme.button && props.theme.button.mainColor, props.theme)};
  color: ${props.theme && props.theme.colors && props.theme.colors.white};
`;

const secondaryStyle = (props) => css`
  border-color: ${props.color ||
  normaliseColor(props.theme && props.theme.button && props.theme.button.mainColor, props.theme)};
`;

const hoverStyle = () => css``;

const AnimationBounceDelay = keyframes`
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
`;

const AnimationRipple = keyframes`
  0% {
    transform: scale(0, 0);
    opacity: 1;
  }
  20% {
    transform: scale(25, 25);
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: scale(40, 40);
  }
`;

const RippleEffectStyles = css`
  :after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 5px;
    height: 5px;
    background: ${(props) => getRGBOpacity(props.theme && props.theme.colors && props.theme.colors.primaryFont, 0.15)};
    opacity: 0;
    border-radius: 100%;
    transform: scale(1, 1) translate(-50%);
    transform-origin: 50% 50%;
  }

  :focus:not(:active)::after {
    animation: ${AnimationRipple} 1s ease-out;
  }
`;

const StyledButtonTextContainer = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  visibility: ${(props) => (props.$showLoading ? 'hidden' : 'visible')};
  height: ${(props) => (props.$showLoading ? '0px' : '100%')};
`;

exports.StyledButtonTextContainer = StyledButtonTextContainer;

const StyledLoadingContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'primary'
})`
  margin: auto;
  width: 100%;
  text-align: center;
  visibility: ${(props) => (props.$showLoading ? 'visible' : 'hidden')};
  height: ${(props) => (props.$showLoading ? '100%' : '0px')};

  > div {
    width: 10px;
    height: 9.5px;
    margin: 0 4px;
    border-radius: 100%;
    display: inline-block;

    background-color: ${(props) =>
      props.primary
        ? props.theme && props.theme.colors && props.theme.colors.white
        : normaliseColor(props.theme && props.theme.button && props.theme.button.textColor, props.theme)};
    -webkit-animation: ${AnimationBounceDelay} 1.4s infinite ease-in-out both;
    animation: ${AnimationBounceDelay} 1.4s infinite ease-in-out both;
  }
`;

exports.StyledLoadingContainer = StyledLoadingContainer;

const StyledButton = styled.button.withConfig({
  shouldForwardProp: (prop) =>
    ['primary', 'secondary', 'tertiary', 'color', 'textColor', 'width', 'margin'].indexOf(prop) === -1
})`
  display: inline-block;
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
  border: none;
  position: relative;
  overflow: hidden;
  border: solid 1px transparent;

  ${basicStyle}
  ${hoverStyle}
  ${(props) => props.primary && primaryStyle(props)}
  ${(props) => props.secondary && secondaryStyle(props)}

  ${RippleEffectStyles}

  ${StyledLoadingContainer} .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  ${StyledLoadingContainer} .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
`;

exports.StyledButton = StyledButton;
